import { useEffect, useRef, useState } from 'react';

const CustomTypeDialog = ({
  dialogRef,
  closeDialog,
  handleAddCustomDetailType,
}) => {
  const bottomRef = useRef(null);

  const [name, setName] = useState('');

  useEffect(() => {
    const clickOutsideDialog = (e) => {
      if (
        dialogRef.current.contains(e.target) &&
        !bottomRef.current.contains(e.target)
      ) {
        closeDialog();
      }
    };

    document.addEventListener('click', clickOutsideDialog);

    return () => {
      document.removeEventListener('click', clickOutsideDialog);
    };
  }, []);

  const handleAddType = () => {
    if (name.trim() === '') {
      return;
    }

    handleAddCustomDetailType(name);
    setName('');
    closeDialog();
  };

  return (
    <dialog
      ref={dialogRef}
      className='w-full h-full max-w-lg max-h-full bg-transparent'
      onCancel={closeDialog}
    >
      <div
        ref={bottomRef}
        className={`bg-secondary fixed bottom-0 w-full max-w-lg rounded-t-3xl px-3 py-6 flex flex-col`}
      >
        <div className='flex items-center justify-between mb-4 text-white'>
          <h1 className='text-xl font-bold'>Add Custom Type</h1>
          <button
            onClick={closeDialog}
            className='text-2xl'
          >
            🅧
          </button>
        </div>
        <div className='flex flex-col gap-2 mb-4'>
          <input
            type='text'
            placeholder='Enter your workout type'
            className='rounded-xl p-2 bg-tertiary  text-white'
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
        </div>
        <button
          onClick={handleAddType}
          className='bg-primary text-white py-3 rounded-full w-full'
        >
          Add
        </button>
      </div>
    </dialog>
  );
};

export default CustomTypeDialog;
